import w_md5 from "../w_md5";
import {
    JSEncrypt
} from "jsencrypt";
//十六进制转字节
function hexToBytes(hex) {
    for (var bytes = [], c = 0; c < hex.length; c += 2)
        bytes.push(parseInt(hex.substr(c, 2), 16));
    return bytes;
}

// 字节转十六进制
function bytesToHex(bytes) {
    for (var hex = [], i = 0; i < bytes.length; i++) {
        hex.push((bytes[i] >>> 4).toString(16));
        hex.push((bytes[i] & 0xF).toString(16));
    }
    return hex.join("");
}

//方法2
JSEncrypt.prototype.encryptLong = function (string) {
    var k = this.getKey();
    try {
        var ct = ""
        //RSA每次加密117bytes，需要辅助方法判断字符串截取位置
        //1.获取字符串截取点
        var bytes = new Array();
        bytes.push(0);
        var byteNo = 0;
        var len, c;
        len = string.length;
        var temp = 0;
        for (var i = 0; i < len; i++) {
            c = string.charCodeAt(i);
            if (c >= 0x010000 && c <= 0x10FFFF) {
                byteNo += 4;
            } else if (c >= 0x000800 && c <= 0x00FFFF) {
                byteNo += 3;
            } else if (c >= 0x000080 && c <= 0x0007FF) {
                byteNo += 2;
            } else {
                byteNo += 1;
            }
            if ((byteNo % 117) >= 114 || (byteNo % 117) == 0) {
                if (byteNo - temp >= 114) {
                    bytes.push(i);
                    temp = byteNo;
                }
            }
        }
        //2.截取字符串并分段加密
        if (bytes.length > 1) {
            for (let i = 0; i < bytes.length - 1; i++) {
                var str;
                if (i == 0) {
                    str = string.substring(0, bytes[i + 1] + 1);
                } else {
                    str = string.substring(bytes[i] + 1, bytes[i + 1] + 1);
                }
                var t1 = k.encrypt(str);
                ct += t1;
            }
            if (bytes[bytes.length - 1] != string.length - 1) {
                var lastStr = string.substring(bytes[bytes.length - 1] + 1);
                ct += k.encrypt(lastStr);
            }
            return hexToBytes(ct);
        }
        var t = k.encrypt(string);
        var y = hexToBytes(t);
        return y;
    } catch (ex) {
        return false;
    }
};

JSEncrypt.prototype.decryptLong = function (string) {
    var k = this.getKey();
    // var MAX_DECRYPT_BLOCK = ((k.n.bitLength()+7)>>3)*2;
    var MAX_DECRYPT_BLOCK = 128;
    try {
        var ct = "";
        var t1;
        var bufTmp;
        var hexTmp;
        var str = bytesToHex(string);
        var buf = hexToBytes(str);
        var inputLen = buf.length;
        //开始长度
        var offSet = 0;
        //结束长度
        var endOffSet = MAX_DECRYPT_BLOCK;
        //分段加密
        while (inputLen - offSet > 0) {
            if (inputLen - offSet > MAX_DECRYPT_BLOCK) {
                bufTmp = buf.slice(offSet, endOffSet);
                hexTmp = bytesToHex(bufTmp);
                t1 = k.decrypt(hexTmp);
                ct += t1;
            } else {
                bufTmp = buf.slice(offSet, inputLen);
                hexTmp = bytesToHex(bufTmp);
                t1 = k.decrypt(hexTmp);
                ct += t1;

            }
            offSet += MAX_DECRYPT_BLOCK;
            endOffSet += MAX_DECRYPT_BLOCK;
        }
        return ct;
    } catch (ex) {
        return false;
    }
};

// btye数组转base64
function arrayBufferToBase64(buffer) {

    var binary = '';

    var bytes = new Uint8Array(buffer);

    var len = bytes.byteLength;

    for (var i = 0; i < len; i++) {

        binary += String.fromCharCode(bytes[i]);

    }

    return window.btoa(binary);

}

// base64转btye数组
function base64ToArrayBuffer(base64) {

    var binary_string = window.atob(base64);

    var len = binary_string.length;

    var bytes = new Uint8Array(len);

    for (var i = 0; i < len; i++) {

        bytes[i] = binary_string.charCodeAt(i);

    }
    return bytes;

}

// const appKey = 'oIDV9w8GZkMnAg4QokdEAffK5lS5Hy';
// const appSecret = '0QiwOBZ4IgvCI9PhPvos6Q4PnajQwdEzxG97xHAITfAslaml4mEKbBiE1Pfu'
// const publicKey = 'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQDGTkGKVu18n+JSS/p65nLEpVCQyabgswDolBzG0g5WIjt/2LaHCAOuPzqK5hmXxClWWdWK2dWRriDVdE5kKW22JUe0IotQ4dsmEtY6b4lPdMEFVMn8gIcyLmIk/UJSv61eRVrULCwdC7SLO4q3KTuohhNUGT5ykhKXjtzmm6G2OwIDAQAB'
// const privateKey = 'MIICdgIBADANBgkqhkiG9w0BAQEFAASCAmAwggJcAgEAAoGBAMZOQYpW7Xyf4lJL+nrmcsSlUJDJpuCzAOiUHMbSDlYiO3/YtocIA64/OormGZfEKVZZ1YrZ1ZGuINV0TmQpbbYlR7Qii1Dh2yYS1jpviU90wQVUyfyAhzIuYiT9QlK/rV5FWtQsLB0LtIs7ircpO6iGE1QZPnKSEpeO3OabobY7AgMBAAECgYADZqwxFzSTgpp7FtqA6RrmzH8JPKwkBm3pj0C/GDMuvv+OPcVDo5uMjYEPiMq/k5mx5XCIJRxIl1fw0UHW7e73vQB+7WlzLHXfkMsTlfpIFpCeu4BpBPuE87aQJJ/MaBTFCzBifSgWmYfM93FXegJkhuDWRGisQvTqvbOTqSywoQJBAPe9S0EuDDUHD51dN/QG6oUdqAi2X/QFzztBFpOpExjkDap4EEhNN1iAuxbcioo39X+rk32UrwGQZoVt1WvAHXcCQQDM6v7EIBiCrrq/k1fhHp8MoT80lcU6Y8r7cFlNXrUzuntu1LeyFoaVgK6bf/UyLQd2Js7mm/IcigERGvEhOY5dAkAW0xPZ33o0cIAZyXrcOr7koMTYeKUCgH6FQQvpcsxVoL05lXI6lxKgTsvt4UfKUDmIF7CxAz/Ubw9i/6mIEd0lAkAvLF3v6m+aDf1hwtq1MWZt8uTpBx17PqPo1ElKnWXbfa+SqReMwNDEs/X+SCu7HFCea3qv7fCDj2WFeY1PF7/lAkEAo20RpBvMhMNNW58r7M4Dv14iyEo+QuBihIGciGykaDzl964xjcXCoHdO/H0JLk+hncUe35F0O8fabjEp9g7ASQ=='

// const jsEncrypt = new JSEncrypt();
// jsEncrypt.setPublicKey(publicKey);
// jsEncrypt.setPrivateKey(privateKey)

function getRulesEncryptStr(appKey,appSecret) {
    let timestamp = Date.now();
    let signStr = w_md5.hex_md5_32Upper(`${appSecret}appKey${appKey}signMethodMD5timestamp${timestamp}v1.0${appSecret}`);
    return `appKey=${appKey}&v=1.0&timestamp=${timestamp}&sign=${signStr}&signMethod=MD5&`;
}

function getParamsEncryptStr(params,publicKey,privateKey) {
    const jsEncrypt = new JSEncrypt();
    jsEncrypt.setPublicKey(publicKey);
    jsEncrypt.setPrivateKey(privateKey)
    let encryptStr = params ? arrayBufferToBase64(jsEncrypt.encryptLong(JSON.stringify(params))) : '';
    return encryptStr ? `param=${encryptStr}` : '';
}


function getDecryptStr(str,publicKey,privateKey) {
    const jsEncrypt = new JSEncrypt();
    jsEncrypt.setPublicKey(publicKey);
    jsEncrypt.setPrivateKey(privateKey)
    return jsEncrypt.decryptLong(base64ToArrayBuffer(str));
}

function getIdDecryptStr(str,publicKey,privateKey) {
    const jsEncrypt = new JSEncrypt();
    jsEncrypt.setPublicKey(publicKey);
    jsEncrypt.setPrivateKey(privateKey)
    return jsEncrypt.encrypt(str + '#' + Date.now())
}

function getPhoneStr(str,publicKey,privateKey) {
    const jsEncrypt = new JSEncrypt();
    jsEncrypt.setPublicKey(publicKey);
    jsEncrypt.setPrivateKey(privateKey)
    return jsEncrypt.encrypt(str)
}



export {
    getRulesEncryptStr,
    getParamsEncryptStr,
    getDecryptStr,
    getIdDecryptStr,
    getPhoneStr,
}